import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'

// 从环境变量读取配置
export const isEnabled = process.env.VUE_APP_API_CRYPTO_ENABLED === 'true'
export const headerFlag = process.env.VUE_APP_API_CRYPTO_HEADER_FLAG
const publicKey = process.env.VUE_APP_RSA_PUBLIC_KEY

// 初始化 RSA 实例（仅在开启且公钥存在时初始化）
let rsaEncrypt = null
if (isEnabled && publicKey) {
  rsaEncrypt = new JSEncrypt()
  rsaEncrypt.setPublicKey(publicKey)
}

// 随机生成 16 位 AES Key
function generateRandomAesKey() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let key = ''
  for (let i = 0; i < 16; i++) {
    key += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return key
}

/**
 * 请求加密
 */
export function encryptRequestData(data) {
  if (!isEnabled || !rsaEncrypt) {
    return {
      encryptedBody: data,
      headerRsa: null,
      aesKey: null
    }
  }

  if (data === undefined || data === null) {
    const aesKey = generateRandomAesKey()
    const base64AesKey = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(aesKey)
    )
    const headerRsa = rsaEncrypt.encrypt(base64AesKey)
    return {
      encryptedBody: null,
      headerRsa,
      aesKey
    }
  }

  // 1. 动态生成 AES Key
  const aesKey = generateRandomAesKey()
  const dataStr = typeof data === 'string' ? data : JSON.stringify(data)

  // 2. AES 加密 Body (ECB + Pkcs7)
  const keyHex = CryptoJS.enc.Utf8.parse(aesKey)
  const encryptedBody = CryptoJS.AES.encrypt(dataStr, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()

  // 3. Base64 编码 AES Key
  const base64AesKey = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(aesKey)
  )

  // 4. RSA 加密 AES Key
  const headerRsa = rsaEncrypt.encrypt(base64AesKey)

  return {
    encryptedBody,
    headerRsa,
    aesKey
  }
}

/**
 * 响应解密
 */
export function decryptResponseData(resData, aesKey) {
  if (!isEnabled || !resData || !aesKey || typeof resData !== 'string') {
    return resData
  }

  try {
    const keyHex = CryptoJS.enc.Utf8.parse(aesKey)
    const bytes = CryptoJS.AES.decrypt(resData, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })

    const jsonStr = bytes.toString(CryptoJS.enc.Utf8)
    if (!jsonStr) {
      throw new Error('AES 解密结果为空')
    }

    return JSON.parse(jsonStr)
  } catch (e) {
    console.error('响应体解密失败:', e)
    throw e
  }
}
